<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="executiveAssociateAudits && executiveAssociateAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list [audits]="executiveAssociateAudits" (nextPage)="onNextPage()">
    </sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Executive Admin audits </ng-template>

  <mat-accordion>
    <mat-expansion-panel
      *ngFor="let executiveAssociatePhoneNumberSkeleton of executiveAssociate.phoneNumbers"
      (opened)="
        executiveAssociatePhoneNumberAuditOpened(
          executiveAssociatePhoneNumberSkeleton.phoneNumberId
        )
      "
    >
      <mat-expansion-panel-header>
        {{ executiveAssociatePhoneNumberSkeleton.phoneNumber }}
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <sd-portal-person-profile-executive-associate-phone-number-audit-list
          #executiveAssociatePhoneNumberAuditList
          [executiveAssociatePhoneNumber]="executiveAssociatePhoneNumberSkeleton.phoneNumberId"
          [loading]="executiveAssociatePhoneNumberAuditsLoading"
          (loadExecutiveAssociatePhoneNumberAudits)="
            loadExecutiveAssociatePhoneNumberAudits.emit($event)
          "
          (nextPage)="nextExecutiveAssociatePhoneNumberAuditPage.emit($event)"
          [executiveAssociatePhoneNumberAudits]="executiveAssociatePhoneNumberAudits"
        >
        </sd-portal-person-profile-executive-associate-phone-number-audit-list>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>

  <mat-accordion>
    <mat-expansion-panel
      *ngFor="let executiveAssociateEmailSkeleton of executiveAssociate.emailAddresses"
      (opened)="executiveAssociateEmailAuditOpened(executiveAssociateEmailSkeleton.emailAddressId)"
    >
      <mat-expansion-panel-header>
        {{ executiveAssociateEmailSkeleton.emailAddress }}
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <sd-portal-person-profile-executive-associate-email-audit-list
          #executiveAssociateEmailAuditList
          [executiveAssociateEmail]="executiveAssociateEmailSkeleton.emailAddressId"
          [loading]="executiveAssociateEmailAuditsLoading"
          (loadExecutiveAssociateEmailAudits)="loadExecutiveAssociateEmailAudits.emit($event)"
          (nextPage)="nextExecutiveAssociateEmailAuditPage.emit($event)"
          [executiveAssociateEmailAudits]="executiveAssociateEmailAudits"
        >
        </sd-portal-person-profile-executive-associate-email-audit-list>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</ng-template>
